import React, { useState, useEffect } from 'react';

import { Login } from './Login.js';
import { Home } from './Home.js';
import { prepAppState } from './utils/init.js';
import './App.scss';


const initialState = {
  // Login
  loggedInUser: null,
  // Home
  // - lobby or game
  waitingOpponent: true,
  // - match duration
  maxTime: 0,
  // - invite
  isInviteMatch: false,
  // - game data (invite or filled)
  players: {
    player1: null,
    player2: null,
    masterName: null,
    masterColor: null,
  },
  room: {
    roomID: null,
    region: 'us', // hardcoded for now @@
  },
};
const initialStateWithParams = prepAppState(initialState);


const App = () => {
  const [appData, setAppData] = useState({ ...initialStateWithParams });

  // LOGIN/LOGOUT
  const handleLogin = (loggedInUser) => {
    setAppData({ ...appData, loggedInUser });
  };
  const handleLogout = () => {
    setAppData({ ...initialState });
  }; 

  return (
    <div className="App">
      {!appData.loggedInUser ? (
        <Login handleLogin={handleLogin} appData={appData} />
      ) : (
        <Home
          setAppData={setAppData}
          handleLogout={handleLogout}
          appData={appData}
        />
      )}
    </div>
  );
}

export default App;
